module.exports = __webpack_public_path__ + "img/clipboard_text_white.079b8da4.svg";